import { Component, Input } from '@angular/core';

@Component({
  selector: 'input-note',
  templateUrl: './input-note.component.html',
  styleUrls: ['../input.scss', './input-note.component.scss']
})
export class InputNoteComponent {
  
  @Input() 
  public note: string = "Test";

  constructor() {}

}
